import React from 'react'
import { socials, footers } from '../../data'
import logo from '../../images/logo.svg'
import './footer.css'
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'react-bootstrap'


const Footer = () => {
  return (
    <Container fluid style={{background: '#FCFCFC',borderTop: '1px solid #000000'}} className='px-auto pt-5 pb-3'>
      <footer className='px-4 mx-md-5 px-md-5' >
        <Row className='align-items-center justify-content-center'>
          <Col className='mb-md-0 mb-5 '>
          <Link to='/'>
          <img src={logo}/>
          </Link>
          </Col>
          <Col >
            <div>
              <Row xs={2} lg={3} classname=''>
              {footers.map((footer) => {
                const {id,text} = footer;
                return(
                  <Col key={id} className='mb-5 '>
                    <a  href='#' className='link-dark text-decoration-none footer-links '>{text}</a>
                  </Col>
                )
              })}

              </Row>

            </div>
            <div className='d-flex mt-1 gap-5'>
            {socials.map((social) => {
                  const {id,url,icon} = social;
                  return(
                    <li key={id}>
                      <a href={url}>{icon}</a>
                    </li>

                  )
                })}
            </div>

          </Col>
        </Row>
        <p className='mt-4 footer-text mx-md-auto mx-4'>Copyright © 2023 Jobbers Lens Inc.</p>
      </footer>
     
    </Container>
    
  )
}

export default Footer
